import { __assign } from 'tslib';
import { colors } from './colors.js';
import * as index from './components/index.js';
import * as scales from './scales.js';
import * as typography from './typography.js';
import * as textCropConfig from './textCropConfig.js';

var theme = __assign(__assign(__assign({ colors: colors, components: index }, scales), typography), textCropConfig);

export { theme };
//# sourceMappingURL=index.js.map
